import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarLinkCard } from 'volto-ministerio-publico-federal/components/UI/SidebarLinkCard';

export interface ServicoRef {
  '@id'?: string;
  '@type'?: string;
  Title?: string;
  url?: string;
  icone?: string;
}

export interface ServicoItem {
  servico?: ServicoRef[];
}

export interface ServicosDestaqueData {
  items?: ServicoItem[];
}

interface MpfServicosDestaqueBlockViewProps {
  data: ServicosDestaqueData;
  isEditMode?: boolean;
}

/**
 * Bloco de sidebar "Serviços em Destaque" (RF05): lista de links cujo
 * rótulo e destino vêm 100% do catálogo oficial (content-type `Servico`) —
 * o editor só escolhe QUAL serviço aparece, nunca edita o texto exibido.
 *
 * Visual (Figma node 3253-164157) e markup compartilhados com o bloco
 * "Conteúdos Relacionados" (RF06) via `SidebarLinkCard` — ver esse
 * componente para o motivo da extração.
 */
export const MpfServicosDestaqueBlockView: React.FC<
  MpfServicosDestaqueBlockViewProps
> = ({ data, isEditMode }) => {
  const items = (data?.items ?? [])
    .map((item) => item.servico?.[0])
    .filter((servico): servico is ServicoRef => !!servico?.url)
    .map((servico) => ({
      key: servico['@id'] as string,
      href: servico.url as string,
      label: servico.Title as string,
    }));

  return (
    <SidebarLinkCard
      title="Serviços em Destaque"
      items={items}
      emptyMessage="Nenhum serviço selecionado. Adicione um item e escolha um serviço do catálogo."
      isEditMode={isEditMode}
    />
  );
};

export default withBlockExtensions(MpfServicosDestaqueBlockView);
